const DepartmentsPrefixEnum = {
    technical: "/06",
    building: "/04",
    legal: "/09",
    administration: "/03",
    technicalAnswer: "06/",
    buildingAnswer: "04/",
    legalAnswer: "09/",
    administrationAnswer: "03/"

};
export default DepartmentsPrefixEnum